export default __webpack_public_path__ + "static/media/pie_2.3032ece6.svg";